var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sc-message--file", style: _vm.messageColors },
    [
      _vm.isGroupMessage
        ? _c(
            "span",
            {
              staticClass: "whatsapp-number-first",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  _vm.showWhatsappChatStarterModal = true
                },
              },
            },
            [
              _c(
                "a",
                {
                  style: { color: _vm.getWhatsappNumberColor() },
                  attrs: { href: "javascript:void(0)" },
                },
                [
                  _vm._v(
                    _vm._s(_vm.whatsappAuthorName) +
                      " - " +
                      _vm._s(_vm.whatsappAuthorNumber)
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "sc-message--file-icon" }, [
        _c("img", {
          staticClass: "sc-image",
          attrs: { src: _vm.data.file.url },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sc-message--file-name", style: _vm.messageColors },
        [
          _c(
            "a",
            {
              attrs: {
                href: _vm.data.file.url ? _vm.data.file.url : "#",
                target: "_blank",
              },
            },
            [_vm._v(_vm._s(_vm.data.file.name || ""))]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sc-message--file-text", style: _vm.messageColors },
        [
          _vm._v("\n        " + _vm._s(_vm.data.text) + "\n        "),
          _vm.data.meta
            ? _c(
                "p",
                { staticClass: "sc-message--meta", style: _vm.messageColors },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.data.meta) + "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.isGroupMessage
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                "justify-content": "end",
                "align-items": "center",
                padding: "0 0.3rem",
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "sc-message-meta-new whatsapp-number",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.showWhatsappChatStarterModal = true
                    },
                  },
                },
                [
                  _c(
                    "a",
                    {
                      style: { color: _vm.getWhatsappNumberColor() },
                      attrs: { href: "javascript:void(0)" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.whatsappAuthorName) +
                          " - " +
                          _vm._s(_vm.whatsappAuthorNumber)
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showWhatsappChatStarterModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.whatsappChatStart"),
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.showWhatsappChatStarterModal = false
                },
              },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "default-phone-number": _vm.whatsappAuthorNumber,
                  "channel-override": "",
                  "phone-number-override": "",
                  "default-name": _vm.whatsappAuthorName,
                },
                on: {
                  close: function ($event) {
                    _vm.showWhatsappChatStarterModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }